module.exports = __webpack_public_path__ + "static/img/tst2-03-1.b026741.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-03-1.gif
// module id = L3Vm
// module chunks = 1